<template>
  <div class="d-flex">
    <b-col lg="3" md="4" sm="6" class="pl-0">
        <b-form-group
            label="Doses previstas*" 
            label-for="doses_previstas" 
            label-class="font_size_label"
        >
            <b-form-input
                id="doses_previstas" 
                v-model="vaccine.quantidade_dose_prevista"
                class="form-control" 
                name="doses_previstas"
                v-mask="'#########'"
                placeholder="--"
                @blur="vaccine.quantidade_dose_prevista = String(Number(vaccine.quantidade_dose_prevista || 0))"
            />
        </b-form-group>
    </b-col>

    <b-col lg="3" md="4" sm="6" class="pl-0">
        <b-form-group 
            label="Doses aplicadas" 
            label-for="doses_aplicadas" 
            label-class="font_size_label"
            v-b-tooltip.hover="{title: 'O número de doses aplicadas será atualizado conforme os colaboradores forem vacinados', customClass: 'custom-tooltip'}"
        >
            <b-form-input
                id="doses_aplicadas" 
                v-model="vaccine.quantidade_dose_aplicada"
                class="form-control" 
                name="doses_aplicadas"
                placeholder="--"
                :disabled="true"
            />
        </b-form-group>
    </b-col>
  </div>
</template>

<script>
import { BCol, BFormGroup, BFormInput} from 'bootstrap-vue'

export default {
  name: 'VaccineDosesForm',
  components: {
    BCol,
    BFormGroup,
    BFormInput
  },
  props: {
    vaccine: {
      type: Object,
      required: true
    }
  }
}
</script>

